
export const getBaseUrl = () => {
  let origin = window.location.origin;
  if (origin.indexOf('.cn') > -1 || origin.indexOf('.com') > -1) {
    return origin;
  } else {
    return 'http://192.168.0.229:19110'
  }
}